import { Box } from "@mui/material";

interface ILinkCellProps {
  value: string;
  onClick: () => void;
}
export const LinkCell = ({ value, onClick }: ILinkCellProps) => {
  return (
    <Box onClick={onClick} sx={{ cursor: "pointer", color: "primary.main" }}>
      {value}
    </Box>
  );
};
